<template>
  <section class="upload">
    <header class="flex-container">
      <form @submit.prevent="handleSearchList(search)">
        <f-search v-model="search" class="input-search"></f-search>
      </form>
      <div class="keywords">
        <span v-for="(term, id) in terms" :key="id" class="term">
          <span>{{ term }}</span>
          <ab-icon icon="close" @click.native="removeTerm(id)"></ab-icon>
        </span>
      </div>
    </header>

    <main>
      <div class="container">
        <form @submit.prevent="handleUploadDocuments" enctype="multipart/form-data">
          <div class="flex flex-center">
              <label for="delivery">Bon de livraison | date('DD MMMM YYYY')</label><input id="delivery" type="radio" name="document" checked="checked">
              <label for="salefigure">Chiffre d'affaires</label><input id="salefigure" type="radio" name="document">
          </div>
          <file-pond
            name="test"
            ref="pond"
            :label-idle="pondLabel"
            :allow-multiple="false"
            :allow-file-type-validation="true"
            :accepted-file-types="pondAcceptedFileType">
          </file-pond>
          <div class="flex flex-right">
            <ab-button class="primary">Importer les documents</ab-button>
          </div>
        </form>
      </div>

      <f-table cols="5">
        <template slot="thead">
          <th></th>
          <th>Fichier</th>
          <th>Utilisateur</th>
          <th>Type</th>
          <th>Date</th>
          <th></th>
          <th>Téléchargé par</th>
        </template>
        <template slot="tbody">
          <tr v-for="(document, index) in documents" :key="index">
            <td class="image_color">
              <ab-icon :icon="icon(document.path)" :class="document.path.split('.')[1]" iconset="load"></ab-icon>
            </td>
            <td>{{ document.label }}</td>
            <td>{{ document.first_name }} {{ document.last_name }}</td>
            <td>{{ document.documentType }}</td>
            <td>{{ document.date | date('DD MMMM YYYY')}}</td>
            <td><a :href="getFilePath(document.path)" :download="document.label" @click="setUserDownload(document.id, index)" class="btn-action primary" target="_blank">Télécharger</a></td>
            <td><span  v-if="document.last_name !== null"><i>{{ document.first_name }} {{ document.last_name }} le {{ document.updatedAt | date('DD MMMM YYYY') }}</i></span></td>
            </tr>
          </tr>
        </template>
      </f-table>
    </main>

    <footer>
      <paginate
        v-model="currentPage"
        :pageCount="pageCount(documents)"
        prev-class="prev"
        next-class="next"
        :containerClass="'f-pagination'">
      </paginate>
    </footer>
    <ab-iconset iconset="load">
      <g id="image">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.6 2.4C2.93726 2.4 2.4 2.93726 2.4 3.6V20.4C2.4 21.0627 2.93726 21.6 3.6 21.6H20.4C21.0627 21.6 21.6 21.0627 21.6 20.4V3.6C21.6 2.93726 21.0627 2.4 20.4 2.4H3.6ZM0 3.6C0 1.61177 1.61177 0 3.6 0H20.4C22.3882 0 24 1.61177 24 3.6V20.4C24 22.3882 22.3882 24 20.4 24H3.6C1.61177 24 0 22.3882 0 20.4V3.6Z" fill="#109CF1"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.8 7.2C7.46863 7.2 7.2 7.46863 7.2 7.8C7.2 8.13137 7.46863 8.4 7.8 8.4C8.13137 8.4 8.4 8.13137 8.4 7.8C8.4 7.46863 8.13137 7.2 7.8 7.2ZM4.8 7.8C4.8 6.14315 6.14315 4.8 7.8 4.8C9.45685 4.8 10.8 6.14315 10.8 7.8C10.8 9.45685 9.45685 10.8 7.8 10.8C6.14315 10.8 4.8 9.45685 4.8 7.8Z" fill="#109CF1"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.9515 8.75147C16.4201 8.28284 17.1799 8.28284 17.6485 8.75147L23.6485 14.7515C24.1172 15.2201 24.1172 15.9799 23.6485 16.4485C23.1799 16.9172 22.4201 16.9172 21.9515 16.4485L16.8 11.2971L4.44853 23.6485C3.9799 24.1172 3.2201 24.1172 2.75147 23.6485C2.28284 23.1799 2.28284 22.4201 2.75147 21.9515L15.9515 8.75147Z" fill="#109CF1"/>
      </g>
      <g id="pdf">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.87868 1.87868C4.44129 1.31607 5.20435 1 6 1H13C13.2652 1 13.5196 1.10536 13.7071 1.29289L20.7071 8.29289C20.8946 8.48043 21 8.73478 21 9V20C21 20.7957 20.6839 21.5587 20.1213 22.1213C19.5587 22.6839 18.7957 23 18 23H6C5.20435 23 4.44129 22.6839 3.87868 22.1213C3.31607 21.5587 3 20.7957 3 20V4C3 3.20435 3.31607 2.44129 3.87868 1.87868ZM6 3C5.73478 3 5.48043 3.10536 5.29289 3.29289C5.10536 3.48043 5 3.73478 5 4V20C5 20.2652 5.10536 20.5196 5.29289 20.7071C5.48043 20.8946 5.73478 21 6 21H18C18.2652 21 18.5196 20.8946 18.7071 20.7071C18.8946 20.5196 19 20.2652 19 20V9.41421L12.5858 3H6Z"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M13 1C13.5523 1 14 1.44772 14 2V8H20C20.5523 8 21 8.44772 21 9C21 9.55228 20.5523 10 20 10H13C12.4477 10 12 9.55228 12 9V2C12 1.44772 12.4477 1 13 1Z"/>
        <path d="M10.4845 9.49675C10.3156 9.75054 10.3398 11.0495 10.5207 11.7805L10.6533 12.3302L10.4362 12.9464C9.85722 14.6139 8.45787 17.1817 7.68592 18.0033C7.39636 18.3114 7.06471 18.5168 6.98625 18.4323C6.85965 18.3055 7.58331 17.3206 8.12621 16.8856C8.51822 16.5713 8.37956 16.5713 7.89701 16.8856C7.22752 17.3266 6.66666 18.0154 6.66666 18.396C6.66666 18.5954 7.0466 18.7282 7.34823 18.6377C7.76438 18.5169 8.57858 17.5502 9.22997 16.4203C9.33258 16.2451 9.40485 16.2089 10.008 16.0458C10.9729 15.7799 11.359 15.6954 12.2696 15.5684L13.0718 15.4477L13.4457 15.6168C14.3444 16.0276 15.4119 16.2451 15.7073 16.0881C15.9667 15.9492 15.9064 15.8887 15.5143 15.8827C15.1344 15.8706 14.0608 15.5626 13.9341 15.4235C13.8556 15.3388 15.2248 15.3993 15.5444 15.496C15.671 15.5323 15.8096 15.6168 15.8579 15.6894C15.9424 15.8041 15.9545 15.8101 15.9905 15.7196C16.0449 15.5686 15.8579 15.3209 15.6106 15.212C15.2969 15.0852 14.5008 15.0187 13.8434 15.0731L13.2705 15.1155L12.8905 14.8738C12.1546 14.4025 11.636 13.756 11.2199 12.7713C11.0088 12.2818 11.0088 12.2697 11.069 11.8287C11.1294 11.3816 11.1535 10.0705 11.0992 10.1249C11.0871 10.1431 11.0267 10.4451 10.9724 10.8016C10.9181 11.158 10.8519 11.4481 10.8277 11.4481C10.7493 11.4481 10.6287 10.4271 10.6649 10.0163C10.677 9.8048 10.7313 9.59334 10.7736 9.53892C10.846 9.44823 10.8641 9.45428 10.9605 9.5752C11.0209 9.64775 11.069 9.74433 11.069 9.7927C11.069 9.83503 11.0992 9.88944 11.1294 9.90742C11.232 9.96789 11.1957 9.53287 11.0931 9.43009C11.0449 9.37568 10.9062 9.33335 10.7975 9.33335C10.6412 9.33366 10.5629 9.36994 10.4845 9.49675ZM11.7571 14.3845C11.9199 14.5718 12.1853 14.8255 12.3482 14.9584C12.6859 15.2243 12.7282 15.182 11.92 15.345C11.3411 15.4658 10.3639 15.7498 9.86944 15.9492C9.65231 16.0278 9.4714 16.0881 9.45933 16.0822C9.45329 16.0701 9.6161 15.7379 9.83323 15.339C10.2192 14.6141 10.7138 13.4661 10.7982 13.0855C10.8404 12.8861 10.8404 12.8861 11.154 13.4661C11.3228 13.7924 11.5943 14.2033 11.7571 14.3845Z"/>
      </g>
    </ab-iconset>
  </section>
</template>

<script>
  import AbButton from '@/components/form/button/ab-button.vue';
  import AbIcon from '@/components/icon/ab-icon.vue';
  import AbIconset from '@/components/icon/ab-iconset.vue';
  import AbInput from '@/components/form/input/ab-input.vue';
  import FSearch from '@/components/form/input/f-search.vue';
  import FTable from '@/components/layout/table/f-table.vue';
  import vueFilePond from 'vue-filepond';
  import Paginate from 'vuejs-paginate';
  import paginationMixin from '@/components/mixins/pagination.js';
  import searchMixin from '@/components/mixins/search.js';
  import { mapState } from 'vuex';
  // Import error message files
  import messages from '../messages/messages.js';

  // Import FilePond styles
  import 'filepond/dist/filepond.min.css';

  // Import image preview and file type validation plugins
  import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';

  // Create component
  // const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);
  const FilePond = vueFilePond(FilePondPluginFileValidateType);

  export default {
    name: 'Upload',
    components: {
      AbButton,
      AbIcon,
      AbIconset,
      AbInput,
      FSearch,
      FTable,
      FilePond,
      Paginate,
    },
    data() {
      return {
        search: '',
        pondLabel: "Glissez votre document ou <u>cliquez ici</u>",
        pondAcceptedFileType: ['image/png', 'image/jpeg', 'image/jpg', 'application/pdf'],
      }
    },
    mixins: [ paginationMixin, searchMixin ],
    computed: {
      ...mapState({ clientId: function(state) { return state.client } }),
      ...mapState({ user: state => { return state.user } }),
      ...mapState({ documents: function(state) { return state.selectors.documents } }),
    },
    methods: {
    async setUserDownload(documentId, index) {
      this.documents[index].first_name = this.user.first_name;
      this.documents[index].last_name = this.user.last_name;
      this.documents[index].updatedAt = Date.now();
      await this.$store.dispatch('userDownload', {
        clientId: this.$store.getters.getClient,
        documentId,
      });
    },
    getFilePath(path) {
      let baseApi = process.env.VUE_APP_ROOT_API;
      return !!path ? `${baseApi}${path}` : false;
    },
      getData(isNewSearch) {
        this.currentPage = isNewSearch ? 1 : this.currentPage;
        if (this.clientId) {
          this.$store.dispatch('getDocuments', {
            terms: this.terms,
            clientId: this.clientId,
            page: this.currentPage,
            limit: 10
          });
        }
      },
      async handleUploadDocuments() {
        const salefigure = this.$el.querySelector('#salefigure').checked;
        const delivery = this.$el.querySelector('#delivery').checked;
        if (!this.$refs.pond.getFile()) {
          this.displayToast({ message: messages.uploads.Upload.custom.emptyFile, mode: "error" });
          return;
        }

        if (!salefigure && !delivery) {
          this.displayToast({ message: messages.uploads.Upload.custom.emptyRadio, mode: "error" });
          return;
        }
        let documentType = 0;
        if (delivery) documentType = 1;
        if (salefigure) documentType = 2;

        let file = this.$refs.pond.getFile().file;
        let formData = new FormData();
        formData.append('fileUpload', file, file.name);

        if (this.clientId) {
          const data = await this.$store.dispatch('createDocument', {
            clientId: this.$store.getters.getClient,
            documentTypeId: documentType,
            data: formData,
          });
          if (data.success) {
            this.displayToast({ message: messages.uploads.Upload.custom.success });
            this.$refs.pond.removeFile();
            this.$router.push({ name: 'Upload' });
          }
        }
      },
      icon(path) {
        return path.split('.')[1] == 'pdf' ? 'pdf' : 'image';
      },
      /* search mixin */
      searchList() {
        let isNewSearch = false;
        const terms = this.$route.query.terms || [];
        if (this.search) isNewSearch = terms.indexOf(this.search) == -1;
        this.getData(isNewSearch);
        this.search = '';
      },
    },
  }
</script>

<style scoped>
  /* Header */
  header {
    margin-bottom: 1.1rem;
  }
  .flex-container {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .input-search {
    min-width: 23rem;
    width: 23rem;
  }
  /* Input File */
  .container {
    background-color: var(--app-white-color);
    padding: 1rem;
    margin-bottom: 1rem;
  }
  #delivery { margin-right: 2rem; }
  /* Table */
  .image_color {
    color: var(--app-primary-color);
    padding: 0 0 0 1.5rem;
  }
  /* Re-size for pdf icon */
  .pdf{
    width: 30px;
    height: 30px;
    margin: 0 2px;
  }
  /* Footer */
  footer { margin-top: 1.1rem; }
</style>
<style src="@/assets/styles/chips.css"></style>
<style src="@/assets/styles/filepond.css"></style>
<style src="@/assets/styles/pagination.css"></style>